import styled from 'styled-components';

import { Input } from 'components';

const CustomInput = styled(Input)`
  width: 100%;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray_500};
  background: transparent;
  outline: none;
  font-size: 1rem;
  color: white;
  border-radius: 0;

  ::placeholder {
    color: ${({ theme }) => theme.colors.white25};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.white25};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.white25};
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    font-size: 1rem;
    padding: 10px 0;

    ${mediaQueries.desktop} {
      font-size: 1.5rem;
      padding: 10px 0;
    }
  `;
  }}

  &:focus {
    border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  }

  &.hasError {
    border-bottom: 1px solid ${({ theme }) => theme.colors.alert_400};
    color: ${({ theme }) => theme.colors.alert_400};

    ::placeholder {
      color: ${({ theme }) => theme.colors.alert_400};
      opacity: 1;
    }

    :-ms-input-placeholder {
      color: ${({ theme }) => theme.colors.alert_400};
    }

    ::-ms-input-placeholder {
      color: ${({ theme }) => theme.colors.alert_400};
    }
  }
`;

export default CustomInput;
